import AuthService from '../services/AuthService';
import router from '@/router';

const user = JSON.parse(localStorage.getItem('user'));

const getDefaultState = () => ({
  all: {},
});

const auth = {
  namespaced: true,
  state: getDefaultState(),
  actions: {
    async RESET_USERS_STATE(context) {
      await context.commit('resetUsers');
    },
    GET_ALL({ commit }) {
      commit('getAllRequest');

      AuthService.getAll().then(
        users => commit('getAllSuccess', users),
        error => commit('getAllFailure', error)
      );
    },
  },
  mutations: {
    resetUsers(state) {
      Object.assign(state, getDefaultState());
    },
    getAllRequest(state) {
      state.all = { loading: true };
    },
    getAllSuccess(state, users) {
      state.all = { items: users };
    },
    getAllFailure(state, error) {
      state.all = { error };
    },
  },
};

export default auth;
